function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: -3.5,
  y: -3.5,
  width: 7,
  height: 7,
  transform: "translate(22 18) rotate(15)",
  fill: "#5BCAEA"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: -3,
  y: -3,
  width: 6,
  height: 6,
  transform: "translate(8 52) rotate(-25)",
  fill: "#EE2F4A"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: -2.5,
  y: -2.5,
  width: 5,
  height: 5,
  transform: "translate(14 82) rotate(35)",
  fill: "#EE2F4A"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(18 118) rotate(10)"
}, React.createElement("rect", {
  x: -1,
  y: -4,
  width: 2,
  height: 8,
  fill: "#fda621"
}), React.createElement("rect", {
  x: -4,
  y: -1,
  width: 8,
  height: 2,
  fill: "#fda621"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(128 12) rotate(-15)"
}, React.createElement("rect", {
  x: -1,
  y: -4,
  width: 2,
  height: 8,
  fill: "#fda621"
}), React.createElement("rect", {
  x: -4,
  y: -1,
  width: 8,
  height: 2,
  fill: "#fda621"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: -3,
  y: -3,
  width: 6,
  height: 6,
  transform: "translate(118 42) rotate(40)",
  fill: "#5BCAEA"
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: -3.5,
  y: -3.5,
  width: 7,
  height: 7,
  transform: "translate(138 62) rotate(-10)",
  fill: "#EE2F4A"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: -2,
  y: -2,
  width: 4,
  height: 4,
  transform: "translate(148 78) rotate(20)",
  fill: "#9e9e9e"
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: -3,
  y: -3,
  width: 6,
  height: 6,
  transform: "translate(122 118) rotate(25)",
  fill: "#fda621"
});

var SvgMedalConfetti = function SvgMedalConfetti(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMedalConfetti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MedalConfetti.b37fd0f0.svg";
export { ForwardRef as ReactComponent };